import type { ContentTableConfig } from "@gplibraries/react/components";

export const techBulletinsTableConfig: ContentTableConfig = {
  columns: {
    bulletin_id: {
      label: 'Document ID',
      headingStyles: {
        mobile: {
          width: '70px'
        }
      }
    },
    bulletin_file: {
      label: 'Document File',
      data_type: 'link',
      headingStyles: {
        mobile: {
          width: '100px'
        }
      }
    },
    bulletin_description: {
      label: 'Document Description',
      headingStyles: {
        desktop: {
          width: '50%'
        },
        mobile: {
          width: '200px'
        }
      }
    },
    effective_date: {
      label: 'Effective Date',
      render: (row: any) => row.effective_date ? new Date(row.effective_date).toLocaleDateString() : '–',
      headingStyles: {
        mobile: {
          width: '80px'
        }
      }
    },
    expiration_date: {
      label: 'Expiration Date',
      render: (row: any) => row.expiration_date ? new Date(row.expiration_date).toLocaleDateString() : '–',
      headingStyles: {
        mobile: {
          width: '80px'
        }
      }
    }
  }
}